var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgR(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 30C0 13.4315 13.4315 0 30 0V0C46.5685 0 60 13.4315 60 30V30C60 46.5685 46.5685 60 30 60V60C13.4315 60 0 46.5685 0 30V30Z",
    fill: "#EFDCAF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5108 40V19.6364H30.3915C31.9824 19.6364 33.2883 19.9081 34.3091 20.4517C35.33 20.9886 36.0856 21.7277 36.5762 22.669C37.0667 23.6103 37.312 24.6809 37.312 25.8807C37.312 27.0805 37.0667 28.1444 36.5762 29.0724C36.0856 30.0005 35.3333 30.7296 34.3191 31.2599C33.3049 31.7836 32.0089 32.0455 30.4313 32.0455H24.8631V29.8182H30.3517C31.4389 29.8182 32.3139 29.6591 32.9767 29.3409C33.6463 29.0227 34.1302 28.572 34.4284 27.9886C34.7334 27.3987 34.8858 26.696 34.8858 25.8807C34.8858 25.0653 34.7334 24.3527 34.4284 23.7429C34.1235 23.133 33.6363 22.6624 32.9668 22.331C32.2973 21.9929 31.4123 21.8239 30.312 21.8239H25.9767V40H23.5108ZM33.0961 30.8523L38.1074 40H35.2438L30.312 30.8523H33.0961Z",
    fill: "#695016"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgR);
export default __webpack_public_path__ + "static/media/r.f7237198350f2cd85f8aa954b76eeefb.svg";
export { ForwardRef as ReactComponent };